const videos = document.querySelectorAll('.youtube-background');
console.log("init youtube slider", videos);

let players = [];
const playButtons = document.querySelectorAll('.y-play-button');
console.log("init playButtons", playButtons);

function onYouTubeIframeAPIReady() {
    console.log("exec onYouTubeIframeAPIReady");
    
    videos.forEach((videoEl, index) => {
        let player = new YT.Player(videoEl.id, {
            videoId: videoEl.dataset.yid,
            playerVars: {                
                'playlist': videoEl.dataset.yid
            },
            events: {
                // Pasamos el índice para saber exactamente qué botón vincular
                'onReady': (event) => onPlayerReady(event, index),
                'onStateChange': onPlayerStateChange,
            },
        });
        players.push(player);
    });
}

function onPlayerReady(event, index) {
    console.log(`exec onPlayerReady for video index ${index}`);
    
    // Vinculamos el evento clic solo a su botón correspondiente
    playButtons[index].addEventListener('click', function() {
        const yswiper = document.querySelector(".product-testimonials__main-slider").swiper;
        if (yswiper && yswiper.autoplay) yswiper.autoplay.stop();
        
        const state = players[index].getPlayerState();
        console.log(`click button for index ${index}, state: ${state}`);
        
        // Si no se está reproduciendo actualmente (estado 1)
        if(state !== 1) {
            // Pausar todos los demás reproductores antes de iniciar este
            players.forEach(p => {
                if(p && typeof p.pauseVideo === 'function') {
                    p.pauseVideo();
                }
            });
            
            // Reproducir este video
            players[index].playVideo();
            
            // Ocultar las portadas y botones de este slide
            const elements = this.closest(".y-slide-wrapper").querySelectorAll('.y-cover-img, .y-play-button, .product-testimonials__main-slider-container');
            elements.forEach(element => {
                element.classList.add("hide");
            });
        } else {
            // Si ya está reproduciendo, lo pausamos
            players[index].pauseVideo();
        }
    });
}

function onPlayerStateChange(event) {
    console.log("exec onPlayerStateChange", event.data);
}

class ProductTestimonialsCustom extends HTMLElement {
  constructor() {
    super();

    console.log('init ProductTestimonialsCustom');
    this.globalSlide = null;
    this.thumbnailSlide = null;

    this.mainSlider = this.querySelector(".product-testimonials__main-slider");
    this.productsSlider = this.querySelector(".product-testimonials__products-slider");
    this.productsSliderMobile = this.querySelector(".product-testimonials__products-slider-mobile");

    this.init();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    if (this.globalSlide) {
      return;
    }

    const settings = theme.helpers.safelyParseJson(this.getAttribute("settings")) || {};

    const defaultSettings = {
      autoplay: true,
      autoplaySpeed: 3000,
    };

    this.settings = { ...defaultSettings, ...settings };

    this.initThumbnail();
    this.initSlide();

    this.initImgThumbnail();

    if (Shopify.designMode) {
      document.addEventListener("shopify:section:load", () => {
        this.initThumbnail();
      });
    }
  }

  initSlide() {
    if (this.settings.autoplay) {
      this.settings.autoplay = {
        delay: this.settings.autoplaySpeed,
        pauseOnMouseEnter: this.settings.pauseOnMouseEnter,
      };
    }

    this.globalSlide = new Swiper(this.mainSlider, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 800,
      autoplay: this.settings.autoplay,
      direction: "horizontal",
      loop: false,
      effect: "fade",
      rewind: true,
      fadeEffect: {
        crossFade: true
      },
      allowTouchMove: true,
      navigation: {
        nextEl: [...Array.from(this.querySelectorAll(".swiper-button-next"))],
        prevEl: [...Array.from(this.querySelectorAll(".swiper-button-prev"))],
      },
      thumbs: {
        swiper: this.thumbnailSlide ? this.thumbnailSlide : null,
      },
      breakpoints: {
        1025: {
          allowTouchMove: false,
        },
      },
      on: {
        slideChange: (slider) => {
            console.log('slide change', slider.realIndex);

            const items = document.querySelectorAll('.y-img-wrapper');
            items.forEach(item => {

              
              item.classList.remove('active');
              

              // Add the 'active' class to the clicked item
              
          });
          
          items[slider.realIndex].classList.add('active');
          players.forEach(player => {
                  console.log(player);
                  if(player) {
                    player.pauseVideo();
                  }
                  
          });
            

          this.productsSliderMobile.globalSlide.slideTo(slider.realIndex, 500);
        }
      }
    });
  }

  initImgThumbnail() {
    // Get all elements that should be part of the group
    const items = document.querySelectorAll('.y-img-wrapper'); // Assuming a class 'my-item' for all elements
    let cInstance = this;

    // Loop through each item and add a click event listener
    items.forEach(item => {
        item.addEventListener('click', function() {
            // Remove the 'active' class from all items
            console.log(this.dataset.index);
            cInstance.functionGoto(this.dataset.index - 1);
            items.forEach(otherItem => {
                otherItem.classList.remove('active');
            });

            // Add the 'active' class to the clicked item
            this.classList.add('active');
        });
    });
  }

  initThumbnail() {
    if (!this.productsSlider) {
      return;
    }

    this.thumbnailSlide = new Swiper(this.productsSlider, {
      effect: "fade",
      itemDesktop: 1,
      itemTablet: 1,
      itemMobile: 1,
      autoHeight: true,
      allowTouchMove: false,
      fadeEffect: {
        crossFade: true
      },
      on: {
        beforeTransitionStart: () => {
          this.productsSlider.classList.add("updating");
        },

        transitionEnd: () => {
          this.productsSlider.classList.remove("updating");
        }
      }
    });
  }

  functionGoto(position) {
    this.globalSlide?.slideTo(position, 500);
  }
}

if (!window.customElements.get("product-testimonials-custom")) {
  customElements.define("product-testimonials-custom", ProductTestimonialsCustom);
}